<script setup lang="ts">
import { useAddressBookStore } from '@/store/addressBook';
import { getAddressSystemLogo } from '@/helpers/getAddressSystemLogo';
import BaseAddress from '@/components/molecules/BaseAddress.vue';

const addressBookStore = useAddressBookStore();
</script>

<template>
  <v-menu activator="parent" location="bottom end" transition="false">
    <v-card class="address-book-dropdown">
      <div style="max-height: 500px" class="rounded overflow-auto">
        <v-list density="compact">
          <v-list-subheader> Wallets </v-list-subheader>
          <v-list-item
            v-if="addressBookStore.items.length === 0"
            title="No wallets saved"
          ></v-list-item>
          <v-list-item
            v-for="item in addressBookStore.items"
            :key="item.address"
            :to="{ name: 'Portfolio', params: { addresses: item.address } }"
          >
            <template #prepend>
              <v-avatar
                rounded="0"
                :image="getAddressSystemLogo(item.address)"
                density="compact"
                size="small"
              ></v-avatar>
            </template>
            <template #title>
              <base-address
                :address="item.address"
                :name="item.name"
                force-short
              ></base-address>
            </template>
          </v-list-item>

          <v-list-item>
            <v-list-item-title class="text-body-2 text-medium-emphasis">
              Bundles
            </v-list-item-title>
            <!-- <template #append>
              <v-btn
                size="24px"
                icon
                variant="plain"
                @click="addressBookStore.openBundleDialog()"
              >
                <v-icon size="small" icon="mdi-plus"></v-icon>
              </v-btn>
            </template> -->
          </v-list-item>

          <v-list-item
            v-if="addressBookStore.bundles.length === 0"
            title="No bundles saved"
          ></v-list-item>
          <v-list-item
            v-for="bundle in addressBookStore.bundles"
            :key="bundle.id"
            :title="bundle.name"
            @click="true"
            :to="{
              name: 'Portfolio',
              params: {
                addresses: bundle.addresses,
                bundleId: bundle.id,
              },
            }"
          >
            <template #prepend>
              <v-avatar density="compact">
                <v-icon icon="mdi-package-variant-closed" />
              </v-avatar>
            </template>
          </v-list-item>
        </v-list>
      </div>
      <v-btn :to="{ name: 'AddressBook' }" class="m-4"
        >Manage address book</v-btn
      >
    </v-card>
  </v-menu>
</template>
